import useApi from "./useApi";
import env from "@beam-australia/react-env";

const useCRUDService = (_entityName) => {
  const api = useApi();

  const entityName = _entityName;

  const getEntities = async (
    columns,
    page,
    pageSize,
    sort,
    order,
    globalFilter,
    prefix,
    posfix
  ) => {
    let uri = `${env("API_URL")}/*PREFIX*/${entityName}/paged/*POSFIX*/`;

    uri = prefix
      ? uri.replace("*PREFIX*", prefix)
      : uri.replace("/*PREFIX*", "");

    uri = posfix
      ? uri.replace("*POSFIX*", posfix)
      : uri.replace("/*POSFIX*", "");

    const response = await api.get(uri, {
      params: {
        columns,
        page,
        pageSize,
        sort,
        order,
        globalFilter,
      },
    });

    return response;
  };

  const getEntity = async (id, prefix, posfix) => {
    let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${id}`;

    uri = prefix
      ? uri.replace("*PREFIX*", prefix)
      : uri.replace("/*PREFIX*", "");

    uri = posfix
      ? uri.replace("*POSFIX*", posfix)
      : uri.replace("/*POSFIX*", "");

    const response = await api.get(uri);
    console.log("GET ENTITY RESPONSE:", response);
    return response.data;
  };

  const createEntity = async (entity, prefix, posfix) => {
    let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*`;

    uri = prefix
      ? uri.replace("*PREFIX*", prefix)
      : uri.replace("/*PREFIX*", "");

    uri = posfix
      ? uri.replace("*POSFIX*", posfix)
      : uri.replace("/*POSFIX*", "");

    await api.post(uri, entity);
  };

  const updateEntity = async (entity, prefix, posfix) => {
    let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${entity.id}`;

    uri = prefix
      ? uri.replace("*PREFIX*", prefix)
      : uri.replace("/*PREFIX*", "");

    uri = posfix
      ? uri.replace("*POSFIX*", posfix)
      : uri.replace("/*POSFIX*", "");

    await api.put(uri, entity);
  };

  const deleteEntity = async (id, prefix, posfix) => {
    let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${id}`;

    uri = prefix
      ? uri.replace("*PREFIX*", prefix)
      : uri.replace("/*PREFIX*", "");

    uri = posfix
      ? uri.replace("*POSFIX*", posfix)
      : uri.replace("/*POSFIX*", "");

    await api.delete(uri);
  };

  return {
    getEntities,
    getEntity,
    createEntity,
    updateEntity,
    deleteEntity,
  };
};

export default useCRUDService;

// import useApi from "./useApi";
// import env from "@beam-australia/react-env";

// const useCRUDService = (_entityName) => {
//   const api = useApi();
//   const entityName = _entityName;

//   const getEntities = async (
//     columns,
//     page,
//     pageSize,
//     sort,
//     order,
//     globalFilter,
//     prefix
//   ) => {
//     const response = prefix
//       ? await api.get(`${env("API_URL")}/${prefix}/${entityName}/paged`, {
//           params: {
//             columns,
//             page,
//             pageSize,
//             sort,
//             order,
//             globalFilter,
//           },
//         })
//       : await api.get(`${env("API_URL")}/${entityName}/paged`, {
//           params: {
//             columns,
//             page,
//             pageSize,
//             sort,
//             order,
//             globalFilter,
//           },
//         });

//     return response;
//   };

//   const getEntity = async (id, prefix, posfix) => {
//     let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${id}`;

//     uri = prefix
//       ? uri.replace("*PREFIX*", prefix)
//       : uri.replace("/*PREFIX*", "");

//     uri = posfix
//       ? uri.replace("*POSFIX*", posfix)
//       : uri.replace("/*POSFIX*", "");

//     const response = await api.get(uri);

//     return response.data;
//   };

//   const createEntity = async (entity, prefix, posfix) => {
//     let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*`;

//     uri = prefix
//       ? uri.replace("*PREFIX*", prefix)
//       : uri.replace("/*PREFIX*", "");

//     uri = posfix
//       ? uri.replace("*POSFIX*", posfix)
//       : uri.replace("/*POSFIX*", "");

//     await api.post(uri, entity);
//   };

//   const updateEntity = async (entity, prefix, posfix) => {
//     let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${entity.id}`;

//     uri = prefix
//       ? uri.replace("*PREFIX*", prefix)
//       : uri.replace("/*PREFIX*", "");

//     uri = posfix
//       ? uri.replace("*POSFIX*", posfix)
//       : uri.replace("/*POSFIX*", "");

//     await api.put(uri, entity);
//   };

//   const deleteEntity = async (id, prefix, posfix) => {
//     let uri = `${env("API_URL")}/*PREFIX*/${entityName}/*POSFIX*/${id}`;

//     uri = prefix
//       ? uri.replace("*PREFIX*", prefix)
//       : uri.replace("/*PREFIX*", "");

//     uri = posfix
//       ? uri.replace("*POSFIX*", posfix)
//       : uri.replace("/*POSFIX*", "");

//     await api.delete(uri);
//   };

//   return {
//     getEntities,
//     getEntity,
//     createEntity,
//     updateEntity,
//     deleteEntity,
//   };
// };

// export default useCRUDService;
